import { ChevronDown, ChevronUp, Trash2 } from 'lucide-react';
import { Button, Input, Badge } from '../../ui';
import type { OutputDef } from '../../features/templates/types';

export interface OutputRowProps {
  output: OutputDef;
  index: number;
  total: number;
  onChange: (patch: Partial<OutputDef>) => void;
  onMove: (delta: number) => void;
  onRemove: () => void;
}

/** Inline editor for one derived-output (formula) spec. */
export function OutputRow({
  output,
  index,
  total,
  onChange,
  onMove,
  onRemove,
}: OutputRowProps) {
  return (
    <div className="rounded-xl border border-surface-border bg-surface-1 p-4">
      <div className="mb-3 flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <Badge tone="accent">Σ {index + 1}</Badge>
          <span className="font-mono text-xs text-zinc-500">
            {output.key || '(no key)'}
          </span>
        </div>
        <div className="flex items-center gap-1">
          <Button
            size="sm"
            variant="ghost"
            aria-label="Move output up"
            disabled={index === 0}
            onClick={() => onMove(-1)}
          >
            <ChevronUp className="h-4 w-4" />
          </Button>
          <Button
            size="sm"
            variant="ghost"
            aria-label="Move output down"
            disabled={index === total - 1}
            onClick={() => onMove(1)}
          >
            <ChevronDown className="h-4 w-4" />
          </Button>
          <Button
            size="sm"
            variant="ghost"
            aria-label="Remove output"
            className="text-red-400 hover:text-red-300"
            onClick={onRemove}
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        <Input
          label="Label"
          value={output.label}
          placeholder="Total effort (days)"
          onChange={(e) => onChange({ label: e.target.value })}
        />
        <Input
          label="Key"
          value={output.key}
          className="font-mono"
          placeholder="totalEffortDays"
          onChange={(e) => onChange({ key: e.target.value })}
        />
        <Input
          label="Expression"
          className="font-mono sm:col-span-2"
          value={output.expression}
          placeholder="backendServices * complexityFactor + buffer"
          onChange={(e) => onChange({ expression: e.target.value })}
        />
      </div>
    </div>
  );
}
